/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SerievideoIdQueryResponse,
  GetApiV1SerievideoIdPathParams,
  GetApiV1SerievideoIdQueryParams,
  GetApiV1SerievideoId401,
  GetApiV1SerievideoId404,
  GetApiV1SerievideoId500,
} from "../../types/serieVideoRegistroController/GetApiV1SerievideoId.ts";

function getGetApiV1SerievideoIdUrl(id: GetApiV1SerievideoIdPathParams["id"]) {
  const res = { method: "GET", url: `/api/v1/serievideo/${id}` as const };
  return res;
}

/**
 * @description Retorna os dados de um vídeo (título/resumo/embed no idioma corrente). **(Requer Authorization para autenticação)**
 * @summary Obter vídeo por ID (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:id}
 */
export async function getApiV1SerievideoId(
  id: GetApiV1SerievideoIdPathParams["id"],
  params?: GetApiV1SerievideoIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SerievideoIdQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerievideoId401
      | GetApiV1SerievideoId404
      | GetApiV1SerievideoId500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SerievideoIdUrl(id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
